"use client";

import PackagesHydrator from "@/components/packagesHydrator";
import PackagesCarousel from "@/components/packagesCardCarousel";
import { IPackages } from "@/interfaces";
import { FlexCenterCol } from "../ui";
import { cn } from "@/lib";
import Image from "next/image";

type Props = {
  className?: string;
  slideClassName?: string;
  packages: IPackages[];
  showHeading?: boolean;
  isWallet?: boolean;
};

export default function PackagesList({
  className,
  slideClassName,
  packages,
  showHeading = true,
  isWallet = false,
}: Props) {
  if (!Array.isArray(packages) || packages.length === 0) {
    if (isWallet) {
      return (
        <FlexCenterCol gap={6} className="size-full grow">
          <figure className={cn("basis-1/2")}>
            <Image
              src="/svg/no-data-amico.svg"
              width={0}
              height={0}
              sizes="100vw"
              className={cn("size-full h-60 object-contain")}
              alt="موردی یافت نشد"
            />
          </figure>
          <p className="text-xl font-bold">موردی یافت نشد</p>
        </FlexCenterCol>
      );
    } else return null;
  }

  return (
    <div className="mx-auto max-w-[700px] lg:max-w-[900px] xl:max-w-full">
      {showHeading ? (
        <div className="flex justify-center">
          <span className="heading-2 text-primary-main mb-6 text-center">
            بسته های استعلامی به صرفه
          </span>
        </div>
      ) : null}
      <PackagesHydrator packages={packages} />
      <PackagesCarousel
        packages={packages}
        className={className}
        slideClassName={slideClassName}
      />
    </div>
  );
}
